<template>
  <div class="tab-content tab-view-grid">
    <grid ref="grid" :config="gridConfig"></grid>
    <editor
      :disabled="!isAvailableToEdit"
      :companyID="companyID"
      :config="{id: gridConfig.id, api: 'SupplierISOs/Get/'}"/>
  </div>
</template>

<script>
import Tab from './../Tab'
import gridConfig from './GridConfig.json'
import { waitValue } from '@/utils/promises'

export default {
  name: 'TabISO',
  mixins: [Tab],
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'Companies' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs['grid'])
    },
    // Mixin Tabs
    handleChangeCompanyID (companyID) {
      this.getGrid()
        .then((grid) => {
          if (!companyID) return
          grid.setFilters(`companyID == ${companyID}`)
          grid.loadData()
        })
    }
  }
}
</script>

<style lang="stylus">
</style>
